import { useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import api from "@/lib/api";
import { eur } from "@/lib/format";
import { Modal, Field, inputCls, useAsync } from "./ui";

const NEW_ITEM = () => ({ kind: "prestation", nom: "", unite: "u", quantite: 1, prix_unitaire: 0, tva: 10 });

export default function AmendmentModal({ quoteId, onClose, onCreated }) {
  const [titre, setTitre] = useState("");
  const [sectionTitre, setSectionTitre] = useState("Travaux supplémentaires");
  const [items, setItems] = useState([NEW_ITEM()]);
  const { busy, run } = useAsync();
  const totalHt = items.reduce((s, it) => s + Number(it.quantite || 0) * Number(it.prix_unitaire || 0), 0);
  const upd = (i, k, v) => setItems(items.map((it, k2) => k2 === i ? { ...it, [k]: v } : it));

  const create = () => run(async () => {
    try {
      const { data } = await api.post(`/billing/quotes/${quoteId}/amendments`, { titre, sections: [{ titre: sectionTitre, items }] });
      toast.success(`Avenant ${data.numero} enregistré (${eur(data.totals.total_ttc)} TTC)`); onCreated(data);
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
  });

  return (
    <Modal title="Nouvel avenant" subtitle="Ajoute (ou retire, avec un prix négatif) des prestations au marché accepté." onClose={onClose} wide testId="amendment-modal">
      <div className="grid sm:grid-cols-2 gap-3 mb-4">
        <Field label="Titre de l'avenant"><input data-testid="av-titre" className={inputCls} value={titre} onChange={e => setTitre(e.target.value)} placeholder="Ex : Ajout salle de bains" /></Field>
        <Field label="Lot / section"><input className={inputCls} value={sectionTitre} onChange={e => setSectionTitre(e.target.value)} /></Field>
      </div>
      <div className="space-y-2">
        {items.map((it, i) => (
          <div key={i} className="grid grid-cols-12 gap-2 items-center bg-white border border-black/10 rounded-rama-sm p-2">
            <input data-testid={`av-item-nom-${i}`} className={`${inputCls} col-span-5`} placeholder="Désignation" value={it.nom} onChange={e => upd(i, "nom", e.target.value)} />
            <input type="number" step="0.01" className={`${inputCls} col-span-2`} placeholder="Qté" value={it.quantite} onChange={e => upd(i, "quantite", e.target.value)} />
            <input className={`${inputCls} col-span-1`} placeholder="U" value={it.unite} onChange={e => upd(i, "unite", e.target.value)} />
            <input type="number" step="0.01" data-testid={`av-item-pu-${i}`} className={`${inputCls} col-span-2`} placeholder="P.U. HT" value={it.prix_unitaire} onChange={e => upd(i, "prix_unitaire", e.target.value)} />
            <select className={`${inputCls} col-span-1`} value={it.tva} onChange={e => upd(i, "tva", Number(e.target.value))}>{[0, 5.5, 10, 20].map(t => <option key={t} value={t}>{t}%</option>)}</select>
            <button onClick={() => setItems(items.filter((_, k) => k !== i))} className="col-span-1 p-2 text-ink-soft hover:text-bordeaux-700" aria-label="Supprimer"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
      <button onClick={() => setItems([...items, NEW_ITEM()])} className="btn-ghost text-sm mt-3"><Plus size={14} /> Ajouter une ligne</button>
      <div className="flex items-center justify-between mt-6 pt-4 border-t border-black/10">
        <div className="text-sm text-ink-soft">Total avenant : <b className="text-anthracite">{eur(totalHt, "always")} HT</b></div>
        <button data-testid="av-create" disabled={busy || !items.some(it => it.nom)} onClick={create} className="btn-primary text-sm disabled:opacity-50">Enregistrer l'avenant</button>
      </div>
    </Modal>
  );
}
